import PenancesTable from "../features/penance/components/penances-table"

export default function PenancesView() {
  return (
    <>
      <PenancesTable />
    </>
  )
}